import React, { useState } from 'react'
import { Translate } from 'gatsby-plugin-translate'
import * as S from './styled'

import { useProductDetailContext } from '../../contexts'
import { SchedulingModal } from '../../SchedulingModal'
import { pushToDataLayerOnModalOpenning } from '../../../utils/tag'

const Unit = () => {
  const [unitState, setUnitState] = useState('SP')
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false)

  const { settings, productDetail } = useProductDetailContext()

  const handleUnitLIstFilteredPerState = e => {
    const unitsFiltered = e.target.value
    setUnitState(unitsFiltered)
  }

  const handleNavLink = originalLink => {
    if (typeof window !== 'undefined') {
      const isVacinasPath = window.location.pathname.includes('vacinas')
      if (isVacinasPath) {
        return originalLink.replace('/agd-exames/', '/vacinas/')
      }
    }
    return originalLink
  }

  const handleScheduleButtonClick = () => {
    setIsScheduleModalOpen(true)
    pushToDataLayerOnModalOpenning({ buttonLabel: 'Agendar' })
  }

  return (
    <>
      <SchedulingModal
        isOpen={isScheduleModalOpen}
        onClose={() => setIsScheduleModalOpen(false)}
        defaultRegion={unitState}
        origin={productDetail.type === 'vacina' ? 'vaccineDetail' : 'examDetail'}
        productId={productDetail.productIdentifier || productDetail.id}
      />
      <S.Aside>
        <S.UnitsContainer>
          <S.UnitsListTitle>
            <Translate>Selecione a unidade desejada</Translate>:
          </S.UnitsListTitle>

          <>
            <S.StatesContainer>
              {['SP', 'RJ'].map((state, index) => (
                <>
                  <S.StatesInputRadio
                    type="radio"
                    id={state}
                    name="stateSelected"
                    value={state}
                    onChange={handleUnitLIstFilteredPerState}
                    defaultChecked={index === 0}
                  />
                  <S.StatesInputLabel htmlFor={state}>{state}</S.StatesInputLabel>
                </>
              ))}
            </S.StatesContainer>

            <S.ScheduleButton onClick={handleScheduleButtonClick}>
              <Translate>Agendar</Translate>
            </S.ScheduleButton>
          </>
        </S.UnitsContainer>
      </S.Aside>
    </>
  )
}
export default Unit
